import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Extension from "@material-ui/icons/ExtensionTwoTone";
import People from "@material-ui/icons/People";
import Warning from "@material-ui/icons/Warning";
// material-ui
import { withStyles } from "@material-ui/styles";
import App from "components/App";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { ChromePicker } from "react-color";
// styles
import styles from "./styles";

class ApplicationDetail extends Component {
  static propTypes = {
    classes: PropTypes.object,
    close: PropTypes.func,
    application: PropTypes.object,
    deleteApplication: PropTypes.func,
    updateApplication: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
    UploadCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    const { application } = this.props;
    const { UploadCenter } = this.context;
    UploadCenter.register(
      this.upload.bind(this),
      this.userDidDrop.bind(this),
      () => console.log("upload callback"),
      undefined
    );
    this.state = {
      ...application,
      index: 0,
      loading: false,
      method: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.refreshKey !== this.props.refreshKey) {
      this.init(nextProps.application);
    }
  }

  async upload() {
    const { UploadCenter } = this.context;
    const { files } = this.state;

    const firstFile = files[0];
    UploadCenter.upload(firstFile).then((r) => {
      this.setState({
        icon: r.payload,
      });
    });
  }

  userDidDrop(files) {
    this.setState({ files, fileLoading: true });
  }

  init(application) {
    //eslint-disable-line
    this.setState({
      ...application,
      loading: false,
    });
  }

  getStepContent(index) {
    const { classes } = this.props;

    const { name, url, loading, deleteValidation, color, icon } = this.state;

    switch (index) {
      case 0:
        return (
          <Grid container spacing={2} className={classes.step}>
            <Grid item>
              <App color={color} name={name} size={90} />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="name"
                fullWidth
                label="Name"
                className={classes.textField}
                value={name}
                onChange={this.handleChange("name")}
                onBlur={() => this.save("name")}
                onKeyPress={(e) => {
                  if (e.key === "Enter") this.save("name");
                }}
                disabled={loading}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="url"
                fullWidth
                label="Url"
                className={classes.textField}
                value={url}
                onChange={this.handleChange("url")}
                onBlur={() => this.save("url")}
                onKeyPress={(e) => {
                  if (e.key === "Enter") this.save("url");
                }}
                disabled={loading}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="icon"
                fullWidth
                label="Icon"
                className={classes.textField}
                value={icon}
                onChange={this.handleChange("icon")}
                onBlur={() => this.save("icon")}
                onKeyPress={(e) => {
                  if (e.key === "Enter") this.save("icon");
                }}
                disabled={loading}
              />
            </Grid>
            <Grid item xs={12}>
              <ChromePicker
                onChangeComplete={() => this.save("color")}
                color={color}
                onChange={(c) => {
                  this.setState({
                    color: c.hex,
                  });
                }}
              />
            </Grid>
          </Grid>
        );
      case 1:
        return (
          <Grid container spacing={2} className={classes.step}>
            <Grid item xs={12}>
              <Typography display="block" variant="h6">
                Delete
              </Typography>
              <Grid item xs={12}>
                <Typography display="block" variant="body2">
                  Enter the application's name to delete
                </Typography>
                <TextField
                  id="email"
                  variant="filled"
                  fullWidth
                  label={`${name}`}
                  className={classes.textField}
                  value={deleteValidation}
                  onChange={this.handleChange("deleteValidation")}
                />
                <br />
                <br />
                <Button
                  variant="contained"
                  style={{
                    opacity: deleteValidation !== name ? 0.5 : 1,
                  }}
                  size="small"
                  disabled={deleteValidation !== name}
                  onClick={this.deleteApplication.bind(this)}
                >
                  Delete Application
                </Button>
              </Grid>
            </Grid>
          </Grid>
        );
      default:
        return (
          <Grid container>
            <Grid item>Unkown Step</Grid>
          </Grid>
        );
    }
  }

  handleCheckboxChange = (name) => (event) => {
    const { target } = event;
    const { checked } = target;

    this.setState({
      [name]: checked,
    });
  };

  handleChange = (name) => (event) => {
    const { target } = event;
    const { value } = target;
    this.setState({
      [name]: value,
    });
  };

  async save(name, numeric) {
    const { updateApplication, refresh, application } = this.props;

    await updateApplication(application.id, {
      [name]: numeric ? Number(this.state[name]) : this.state[name],
    });

    this.setState({
      loading: false,
    });

    refresh();
  }

  async deleteApplication() {
    const { application, deleteApplication, close, refresh } = this.props;
    await deleteApplication(application.id);
    refresh();
    close();
  }

  render() {
    const { classes } = this.props;
    const { index, name, id } = this.state;

    return (
      <Grid container className={classes.container} direction="column">
        <Grid
          item
          style={{
            height: "calc(100vh - 57px)",
            width: "100%",
            overflowY: "scroll",
            overflowX: "hidden",
            borderBottom: "solid 1px rgba(155, 155, 155, 0.3)",
          }}
        >
          <div
            style={{
              padding: 16,
              borderBottom: "solid 1px rgba(155, 155, 155, 0.3)",
            }}
          >
            <Grid container spacing={1}>
              <Grid item>
                <Extension fontSize="large" />
              </Grid>
              <Grid item>
                <Typography display="block" variant="h6">
                  {name}
                </Typography>
                <Typography
                  display="block"
                  variant="caption"
                  color="textSecondary"
                >
                  #{id}
                </Typography>
              </Grid>
            </Grid>
          </div>
          {this.getStepContent(index)}
        </Grid>
        <Grid item>
          <BottomNavigation
            value={index}
            onChange={(event, newIndex) => {
              this.setState({ index: newIndex });
            }}
            showLabels
            className={classes.root}
          >
            <BottomNavigationAction label="General" icon={<People />} />
            <BottomNavigationAction label="Danger" icon={<Warning />} />
          </BottomNavigation>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(ApplicationDetail);
